import React, { useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import axios from "axios";

const AddProduct = () => {
  const [productData, setProductData] = useState({
    name: "",
    manufacturer: "",
    productType: "",
    diameter: "",
    description: "",
    sizes: [],
    range: "",
    accuracy: "",
    photos: [],
    applications: [],
    tags: [], 
    technicalDetails: [], 
    brochure: "", 
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleArrayChange = (field, index, value) => {
    const newArray = [...productData[field]];
    newArray[index] = value;
    setProductData((prevState) => ({
      ...prevState,
      [field]: newArray,
    }));
  };

  const handleApplicationChange = (index, value) => {
    const newApplications = [...productData.applications];
    newApplications[index] = value;
    setProductData((prevState) => ({
      ...prevState,
      applications: newApplications,
    }));
  };

  const handleAddApplication = () => {
    setProductData((prevState) => ({
      ...prevState,
      applications: [...prevState.applications, ""],
    }));
  };

  const handleRemoveApplication = (index) => {
    const newApplications = productData.applications.filter(
      (_, i) => i !== index
    );
    setProductData((prevState) => ({
      ...prevState,
      applications: newApplications,
    }));
  };

  const handleAddField = (field) => {
    setProductData((prevState) => ({
      ...prevState,
      [field]: [...prevState[field], ""],
    }));
  };

  const handleRemoveField = (field, index) => {
    const newArray = productData[field].filter((_, i) => i !== index);
    setProductData((prevState) => ({
      ...prevState,
      [field]: newArray,
    }));
  };

  // Handle file uploads using React Dropzone
  const onDrop = useCallback((acceptedFiles) => {
    setProductData((prevState) => ({
      ...prevState,
      photos: [...prevState.photos, ...acceptedFiles],
    }));
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("name", productData.name);
      formData.append("manufacturer", productData.manufacturer);
      formData.append("productType", productData.productType);
      formData.append("diameter", productData.diameter);
      formData.append("description", productData.description);
      formData.append("brochure", productData.brochure); 

      productData.applications.forEach((app) =>
        formData.append("applications[]", app)
      );
      productData.tags.forEach((tag) => formData.append("tags[]", tag));
      productData.technicalDetails.forEach((detail) =>
        formData.append("technicalDetails[]", detail)
      );
      productData.photos.forEach((file) => {
        formData.append("photos", file);
      });

      const response = await axios.post(
        "http://localhost:5000/products",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      console.log("Product Added:", response.data);
      alert("Product added successfully!");
      setProductData({
        name: "",
        manufacturer: "",
        productType: "",
        description: "",
        diameter: "",
        sizes: [],
        range: "",
        accuracy: "",
        applications: [],
        tags: [],
        technicalDetails: [],
        brochure: "",
        photos: [],
      });
    } catch (err) {
      console.error("Error adding product:", err.response?.data || err.message);
    }
  };

  return (
    <div className="max-w-3xl mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h1 className="text-3xl font-semibold text-center text-gray-800 mb-6">
        Add New Product
      </h1>
      <form onSubmit={handleSubmit}>
        {/* Name */}
        <div className="mb-4">
          <label className="block text-gray-600 font-medium mb-2">
            Product Name:
          </label>
          <input
            type="text"
            name="name"
            value={productData.name}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg"
            required
          />
        </div>

        {/* Manufacturer Input */}
        <div className="mb-4">
          <label className="block text-gray-600 font-medium mb-2">
            Manufacturer:
          </label>
          <input
            type="text"
            name="manufacturer"
            value={productData.manufacturer}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg"
            placeholder="Enter manufacturer's name"
            required
          />
        </div>

         {/* Product Type Input */}
         <div className="mb-4">
          <label className="block text-gray-600 font-medium mb-2">
            Product Type:
          </label>
          <input
            type="text"
            name="productType"
            value={productData.productType}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg"
            placeholder="Enter product type"
            required
          />
        </div>

        {/* Product Application Input */}
        <div className="mb-4">
          <label className="block text-gray-600 font-medium mb-2">
            Applications:
          </label>
          {productData.applications.map((app, index) => (
            <div key={index} className="flex items-center space-x-2 mb-2">
              <input
                type="text"
                value={app}
                onChange={(e) => handleApplicationChange(index, e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                placeholder={`Application ${index + 1}`}
              />
              <button
                type="button"
                onClick={() => handleRemoveApplication(index)}
                className="text-red-500 font-bold"
              >
                ✖
              </button>
            </div>
          ))}
          <button
            type="button"
            onClick={handleAddApplication}
            className="mt-2 text-indigo-600 font-semibold"
          >
            + Add Application
          </button>
        </div>

        {/* Description Input */}
        <div className="mb-4">
          <label className="block text-gray-600 font-medium mb-2">
            Description:
          </label>
          <textarea
            name="description"
            value={productData.description}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg"
            placeholder="Enter product description"
            rows="4"
            required
          />
        </div>

        {/* Diameter Input */}
        <div className="mb-4">
          <label className="block text-gray-600 font-medium mb-2">
            Diameter:
          </label>
          <input
            type="text"
            name="diameter"
            value={productData.diameter}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg"
            placeholder="Enter diameter"
          />
        </div>

        {/* Brochure Link */}
        <div className="mb-4">
          <label className="block text-gray-600 font-medium mb-2">
            Brochure Link:
          </label>
          <input
            type="url"
            name="brochure"
            value={productData.brochure}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg"
            placeholder="Enter brochure URL"
          />
        </div>

        {/* Tags Input */}
        <div className="mb-4">
          <label className="block text-gray-600 font-medium mb-2">Tags:</label>
          {productData.tags.map((tag, index) => (
            <div key={index} className="flex items-center space-x-2 mb-2">
              <input
                type="text"
                value={tag}
                onChange={(e) => handleArrayChange("tags", index, e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
              />
              <button
                type="button"
                onClick={() => handleRemoveField("tags", index)}
                className="text-red-500 font-bold"
              >
                ✖
              </button>
            </div>
          ))}
          <button
            type="button"
            onClick={() => handleAddField("tags")}
            className="mt-2 text-indigo-600 font-semibold"
          >
            + Add Tag
          </button>
        </div>

        {/* Technical Details Input */}
        <div className="mb-4">
          <label className="block text-gray-600 font-medium mb-2">
            Technical Details:
          </label>
          {productData.technicalDetails.map((detail, index) => (
            <div key={index} className="flex items-center space-x-2 mb-2">
              <input
                type="text"
                value={detail}
                onChange={(e) =>
                  handleArrayChange("technicalDetails", index, e.target.value)
                }
                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                placeholder={`Detail ${index + 1}`}
              />
              <button
                type="button"
                onClick={() => handleRemoveField("technicalDetails", index)}
                className="text-red-500 font-bold"
              >
                ✖
              </button>
            </div>
          ))}
          <button
            type="button"
            onClick={() => handleAddField("technicalDetails")}
            className="mt-2 text-indigo-600 font-semibold"
          >
            + Add Technical Detail
          </button>
        </div>

        {/* Dropzone for file upload */}
        <div className="mb-4">
          <label className="block text-gray-600 font-medium mb-2">
            Photos:
          </label>
          <div
            {...getRootProps()}
            className="border-dashed border-2 border-gray-400 p-6 text-center cursor-pointer rounded-lg bg-gray-50"
          >
            <input {...getInputProps()} />
            <p className="text-gray-500">
              Drag & drop some files here, or click to select files
            </p>
          </div>

          {/* Preview uploaded images */}
          {productData.photos.length > 0 && (
            <div className="mt-4 grid grid-cols-3 gap-4">
              {productData.photos.map((file, index) => (
                <div key={index} className="relative">
                  <img
                    src={URL.createObjectURL(file)}
                    alt={`upload-${index}`}
                    className="w-full h-24 object-cover rounded-lg"
                  />
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Submit */}
        <div className="text-center">
          <button
            type="submit"
            className="bg-indigo-600 text-white px-6 py-2 rounded-lg text-lg font-medium"
          >
            Add Product
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddProduct;
